import { getContext } from 'svelte';
export const useThrelte = () => {
    const context = getContext('threlte');
    if (context === undefined) {
        throw new Error('No Threlte context found, are you using this hook inside of <Canvas>?');
    }
    return context;
};
